import { render, staticRenderFns } from "./PayIDClient.vue?vue&type=template&id=fd247b30&"
import script from "./PayIDClient.vue?vue&type=script&lang=js&"
export * from "./PayIDClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports